import PlayerAvatar from "../user/avatar";
import { getApproximateTimeString } from "@/src/util/relativetime";
import { useState } from "react";
import styles from './news.module.css';
import HomeNewsPostDeleteButton from "./newspostdeletebutton";

type Props = {
    newsPostId: number;
    title: string;
    authorName: string | null;
    authorAvatar?: string | null;
    date: number;
    content: string;
    onDeletePost: (newsPostId: number) => void;
}

export default function NewsPost(
    {
        title,
        authorName,
        authorAvatar,
        date,
        content,
        newsPostId,
        onDeletePost,
    }: Props,
): JSX.Element {
    const [now] = useState<number>(() => Date.now());
    const dateString = getApproximateTimeString(date, now);
    const authorDisplayName = authorName ?? 'Unknown';
    const fullDateString = new Date(date).toLocaleString();

    return (
        <article className={styles.post}>
            <div className={styles.header}>
                <div className={styles.headingGroup}>
                    <h3 className={styles.title}>
                        {title}
                    </h3>
                    <div className={styles.subtitle}>
                        <PlayerAvatar
                            src={authorAvatar ?? undefined}
                            className={styles.author}
                            title={authorDisplayName}
                        />
                        <span className={styles.authorName}>{authorDisplayName}</span>
                        <span className={styles.metadataSeparator} aria-hidden="true" />
                        <time dateTime={new Date(date).toISOString()} title={fullDateString}>
                            {dateString} ago
                        </time>
                    </div>
                </div>
                <HomeNewsPostDeleteButton
                    newsPostId={newsPostId}
                    title={title}
                    onDeletePost={onDeletePost}
                />
            </div>

            <div className={styles.content}>
                {content}
            </div>
        </article>
    );
}
